// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__326NK","log":"ModalInventoryLogs_log__1Tv2k","date":"ModalInventoryLogs_date__Cdkbe","userName":"ModalInventoryLogs_userName__2js_7"};